export const HERO_HEADLINE_LINE_1 = "Hi, I'm Jam a";
export const HERO_HEADLINE_LINE_2 = 'Full Stack AI Developer';
export const HERO_HEADLINE_TEXT = `${HERO_HEADLINE_LINE_1}${HERO_HEADLINE_LINE_2}`;

export const PANINDA_FEATURES = [
  'Real-time inventory tracking with low-stock alerts',
  'Secure transaction logging and permanent sales history',
  'Business insights and reports for data-driven decisions',
  'Full operator control with strong data security',
];

export const ALGOSENSEI_VIDEO = `${process.env.PUBLIC_URL}/algosensei/4063a2a7-5f7c-4411-86ce-a1c4736e9011.mp4`;

export const ALGOSENSEI_IMAGES = [
  `${process.env.PUBLIC_URL}/algosensei/1.jpeg`,
  `${process.env.PUBLIC_URL}/algosensei/2.jpeg`,
  `${process.env.PUBLIC_URL}/algosensei/3.jpeg`,
  `${process.env.PUBLIC_URL}/algosensei/4.jpeg`,
];

export const ALGOSENSEI_FEATURES = [
  'Structured algorithm lessons for guided learning',
  'Clean learning interface for reviewing core concepts',
  'Practice-focused flow for strengthening problem-solving skills',
  'Organized content experience for students learning at their own pace',
];
